var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCollections({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5313 21C17.9286 21 18.25 20.7206 18.25 20.375C18.25 20.0294 17.9286 19.75 17.5313 19.75H2.4375V7.25H22.5625V19.75H20.4063C20.0089 19.75 19.6875 20.0294 19.6875 20.375C19.6875 20.7206 20.0089 21 20.4063 21H22.5625C23.356 21 24 20.44 24 19.75V7.25C24 6.56 23.356 6 22.5625 6H2.4375C1.644 6 1 6.56 1 7.25V19.75C1 20.44 1.644 21 2.4375 21H17.5313Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.416667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15625 4.75C2.75885 4.75 2.4375 4.47056 2.4375 4.125C2.4375 3.77944 2.75885 3.5 3.15625 3.5H21.8438C22.2411 3.5 22.5625 3.77944 22.5625 4.125C22.5625 4.47056 22.2411 4.75 21.8438 4.75H3.15625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.416667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 2.25C4.19635 2.25 3.875 1.97056 3.875 1.625C3.875 1.27944 4.19635 1 4.59375 1H20.4063C20.8036 1 21.125 1.27944 21.125 1.625C21.125 1.97056 20.8036 2.25 20.4063 2.25H4.59375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.416667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCollections);
export default __webpack_public_path__ + "static/media/NavCollections.cded5a702c865932121b20a83910fc2e.svg";
export { ForwardRef as ReactComponent };